import lessonApi from 'Api/axios/lesson-api';
import { useEffect, useState } from 'react';
import { TestConfigurationI } from 'types';

interface Props {
  init?: boolean;
  lessonId: string;
}

const useEvaluationConfiguration = ({ lessonId, init = false }: Props) => {
  const [configuration, setConfiguration] = useState<TestConfigurationI>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  /**
   * Obtiene los parámetros de configuración del examen.
   * #### Como por ejemplo;
   * 1. El orden de las preguntas.
   * 2. El tiempo de duración del examen.
   * 3. Si se permite el cambio de página.
   *
   * @param lessonId - Id de la lección.
   */
  const getConfiguration = async (lessonId: string) => {
    setLoading(true);
    const response = await lessonApi.getTestConfiguration(lessonId);
    setLoading(false);
    setError(response.error);
    setConfiguration(response.data);
  };

  useEffect(() => {
    if (init === true) {
      getConfiguration(lessonId);
    }
  }, [init, lessonId]);

  return {
    configuration,
    loading,
    error,
    getConfiguration,
  };
};

export default useEvaluationConfiguration;
